<template>
  <div>
    <div class="dao-header">
      <span class="title">
        {{ $t("auCapitals.dao.title") }}
      </span>
      <RouterLink
        class="link"
        :to="`/dao-tokens/${id}`"
      >
        {{ $t(`auCapitals.dao.allDao`) }}
      </RouterLink>
    </div>
    <div
      v-for="(dao, index) in daoRequests"
      :key="index"
      class="info"
    >
      <div class="info_column">
        <RouterLink
          :to="`/dao-tokens/${id}#${dao?.id}`"
          class="fs13 info_underline"
        >
          {{ dao?.name }}
        </RouterLink>
        <span class="info_small info_delicate">
          {{ formatDescription(dao?.description) }}
        </span>
      </div>
      <span class="fs11 info_delicate">
        {{ formatDate(dao?.dateStart) }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default ({
  name: "DAO",
  props: {
    id: {
      type: Number,
      default: 0
    },
    daoRequests: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },

    formatDescription(description) {
      return description.length < 26 ? description : description.slice(0, 22) + "...";
    }
  }
});
</script>

<style scoped lang="scss">
.dao-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .title {
    font-size: 16px;
    font-weight: 500;
  }

  .link {
    color: #279063;
  }
}
.info {
  display: flex;
  justify-content: space-between;

  &_column {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &_faded {
    color: var(--color-50);
  }

  &_delicate {
    color: var(--color-60);
  }

  &_spread {
    display: flex;
    justify-content: space-between;
  }

  &_small {
    font-size: 10px;
  }

  &_underline {
    text-decoration: underline;
    cursor: pointer;
    color: var(--text-color);
  }
}
</style>